export default {
  'Are you sure to delete the configuration item?':
    'Are you sure to delete the configuration item?',
  'Add configuration item': 'Add configuration item',
  'Quick configuration entry': 'Quick configuration entry',
  'Variable name': 'Variable name',
  'Variable grouping': 'Variable grouping',
  'Variable title': 'Variable title',
  'Variable description': 'Variable description',
  'Variable type': 'Variable type',
  'Dictionary data': 'Data dictionary',
  'One line at a time, without quotation marks, for example: key1=value1':
    'One per line, no quotation marks required, such as: key1=value1',
  'Validation rules': 'Verification rules',
  'Extended properties': 'Extended properties',
  'One attribute per line without quotation marks':
    'One attribute per line, no quotation marks required, such as: class=config-item',
  weight: 'Weight',
  number: 'Number',
  'Please enter the recipient email address':
    'Please enter the recipient email address',
  'Test mail sending': 'Test mail sending',
  'send out': 'send',
  'Please enter the correct email address':
    'Please enter the correct email address',
  Sending: 'Sending',
  'Please enter the correct mail configuration':
    'Please enter the correct mail configuration'
}
